import React, { Component } from "react";
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

export class ErrorBoundaries extends Component {
  state = {
    hasError: false,
    error: null,
    info: null,
  };

  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      error,
      info,
    });
  }

  static getDerivedStateFromError(error, info) {
    return {
      error,
      info,
    };
  }

  render() {
    if (this.state.hasError) {
      return (
        <React.Fragment>
            <h1>{this.state.error.toString()}</h1>
          {/* <CssBaseline />
          <Container maxWidth="sm">
            <Box sx={{ bgcolor: "red", height: "100vh" }}>
                {this.state.error.toString()}
            </Box>
          </Container> */}
        </React.Fragment>
      );
    } else {
      return this.props.children;
    }
  }
}
